import { categoryLabel } from "helpers/categoryLabel";
import { useState } from "react";
import Filter from "../../../../components/Filter/Filter";
import scss from "./styles.module.scss";

const Filters = ({
    selectedFilters,
    setSelectedFilters,
    availableFilters,
    changeFilters,
    setTempSelectedFilters,
    setChangeFilters,
    tempSelectedFilters,
    sort,
    setSort,
    setCurrentPage,
    lastSelectedFilterKey,
    setLastSelectedFilterKey,
}) => {
    const [openKeys, setOpenKeys] = useState([]);

    const toggleFilter = (key) => {
        setOpenKeys((current) => (current.includes(key) ? current.filter((openKey) => openKey !== key) : [...current, key]));
    };

    return (
        <>
            <div className={scss.scrollArea}>
                {availableFilters?.map((filter) => {
                    const isOpen = openKeys.includes(filter.key);
                    return (
                        <div className={`${scss.filterCard} ${isOpen ? scss.filterCardOpen : ""}`} key={filter.key}>
                            <button type="button" className={scss.filterHeader} aria-expanded={isOpen} onClick={() => toggleFilter(filter.key)}>
                                <span>{categoryLabel(filter?.name)}</span>
                                <svg className={isOpen ? scss.chevronOpen : scss.chevron} viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                    <path d="m7.5 4.5 5.5 5.5-5.5 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>

                            {isOpen && (
                                <div className={scss.filterContent}>
                                    <Filter
                                        filter={filter}
                                        selectedFilters={selectedFilters}
                                        setTempSelectedFilters={setTempSelectedFilters}
                                        changeFilters={changeFilters}
                                        setChangeFilters={setChangeFilters}
                                        setSelectedFilters={setSelectedFilters}
                                        tempSelectedFilters={tempSelectedFilters}
                                        setCurrentPage={setCurrentPage}
                                        setLastSelectedFilterKey={setLastSelectedFilterKey}
                                        lastSelectedFilterKey={lastSelectedFilterKey}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Filters;
